import { render, staticRenderFns } from "./tick.vue?vue&type=template&id=3753e324&scoped=true&"
import script from "./tick.vue?vue&type=script&lang=js&"
export * from "./tick.vue?vue&type=script&lang=js&"
import style0 from "./tick.vue?vue&type=style&index=0&id=3753e324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3753e324",
  null
  
)

export default component.exports